import { jsxs as p, jsx as t } from "react/jsx-runtime";
import { c as v } from "./clsx-OuTLNxxd.js";
import { I as o } from "./icon-DtMxVF3r.js";
import "./components/elements/icon/iconsList.js";
import { useCounter as x } from "./components/elements/inputs/counter/counter.hooks.js";
const h = "_container_v3tha_29", f = "_error_v3tha_43", y = "_disabled_v3tha_46", C = "_label_v3tha_66", e = {
  container: h,
  error: f,
  disabled: y,
  "group-container": "_group-container_v3tha_62",
  label: C
}, k = ({
  inputInitialValue: c,
  placeholderForZero: n,
  onChange: d,
  minValue: m = 0,
  maxValue: u = 1e3,
  disabled: a = !1,
  hasError: r
}) => {
  const { value: s, increment: b, decrement: _, incrementIsDisabled: l, decrementIsDisabled: i } = x(
    c,
    m,
    u,
    a,
    d
  );
  return /* @__PURE__ */ p("div", { className: e.container, children: [
    /* @__PURE__ */ t("button", { type: "button", onClick: _, disabled: i, "aria-label": "counter-decrementer", children: /* @__PURE__ */ t(
      o,
      {
        className: `${i && e.disabled} ${r && e.error}`,
        name: "minus",
        size: "2xl"
      }
    ) }),
    /* @__PURE__ */ t(
      "input",
      {
        className: v(a && e.disabled),
        readOnly: !0,
        type: "text",
        value: s === 0 && n ? n : s,
        "aria-label": "input-value"
      }
    ),
    /* @__PURE__ */ t("button", { type: "button", onClick: b, disabled: l, "aria-label": "counter-incrementer", children: /* @__PURE__ */ t(
      o,
      {
        className: `${l && e.disabled} ${r && e.error}`,
        name: "plus",
        size: "2xl"
      }
    ) })
  ] });
};
export {
  k as C,
  e as s
};
